module.exports = __webpack_public_path__ + "img/thumbnail-cedrow-benefis-policy.0ab31034.png";